import React, { useRef, useState, FC } from 'react';
import {
  Grid, Box, Button, TextField,
} from '@mui/material';
import dynamic from 'next/dynamic';
import StyledGrid from 'views/rebranded-module/common/components/UI/ParticipatingLocations/ParticipatingLocation.styles';
import { useSelector } from 'redux/app/store';
import { LocationsGroup } from 'views/rebranded-module/common/components/UI/ParticipatingLocations';
import {
  Typography700,
} from 'views/rebranded-module/common/components';
import { RiSearchLine, RiExternalLinkLine } from 'react-icons/ri';
import { useContent } from 'views/rebranded-module/common/context/useContent';
import PATHS from 'lib/navigation/paths';

const Map = dynamic(() => import('views/common/components/UI/Map').then((file) => file.Map));

const ParticipatingLocations: FC<any> = (props) => {
  const {
    className,
    mapGroupsTitle,
    mapGroupSubTitle,
    locationsGroup,
    defaultZoom,
    mapCenter,
    mapLocations,
    mapIcon,
    mapIconAlt,
    handleTextFieldSearch,
    handleMapLogoClick,
    prepareMapUrl,
    handleMapOnChange,
    renderMapMarkers,
    handleLocationCardButtonClick,
    target,
    selectedLocationId,
    placeholder,
    titleSizeVariant,
    subTitleSizeVariant,
    showExternalLink = false,
    content: propsContent,
  } = props;
  const participatingLocationsFromUseContent = useContent('ParticipatingLocationsComponent');
  const content = participatingLocationsFromUseContent || propsContent;

  const { isCrawler } = useSelector((state) => state.globalData);
  const [showMap, setShowMap] = useState(!isCrawler);
  const searchInputRef = useRef();
  const handleShowMapClick = () => {
    setShowMap(true);
  };

  return (
    <StyledGrid
      container
      spacing={4}
      className={className}
    >
      <Grid item lg={6} md={12}>
        <Typography700 variant={titleSizeVariant || 'h3'} component="p" className="PLSectionTitle">
          {mapGroupsTitle}
        </Typography700>
        {mapGroupSubTitle && (
          <Typography700
            variant={subTitleSizeVariant || 'h6'}
            component="p"
            className="PLSectionSubTitle">
            {mapGroupSubTitle}
          </Typography700>
        )}
        {showExternalLink && (
          <Box
            component="span"
            className="PLExternalLinkIcon"
            onClick={(e) => {
              e.stopPropagation();
              const url = PATHS.clubLocations({
                ref: 'motorcycle_subscription',
              }).url;
              window.open(url, '_blank');
            }}>
            <RiExternalLinkLine />
          </Box>
        )}
        {handleTextFieldSearch && (
          <Box className="PLSearchInputContainer">
            <TextField
              className="PLInput"
              inputRef={searchInputRef}
              onChange={handleTextFieldSearch}
              placeholder={placeholder}
              value={null}
              fullWidth
            />
            <Box className="PLSearchIconWrapper">
              <RiSearchLine />
            </Box>
          </Box>
        )}
        <Box id="locationsList" className="PLLocationsList">
          {locationsGroup.map((location) => (
            <LocationsGroup
              key={location.name}
              location={location}
              prepareMapUrl={prepareMapUrl}
              handleLocationCardButtonClick={handleLocationCardButtonClick}
              selectedLocationId={selectedLocationId}
              target={target}
              searchValue={searchInputRef?.current?.value}
              content={content}
            />
          ))}
        </Box>
      </Grid>
      <Grid item lg={6} md={12}>
        <Box className="PLMapSide">
          {isCrawler && !showMap ? (
            <Box className="PLMapPlaceholder">
              <Button variant="contained" color="primary" onClick={handleShowMapClick}>{content.showMapBtnText}</Button>
            </Box>
          ) : (
            <Map
              mapCenter={mapCenter}
              mapLocations={mapLocations}
              mapIcon={mapIcon}
              mapIconAlt={mapIconAlt}
              handleMarkerClick={handleMapLogoClick}
              mapZoom={defaultZoom}
              handleMapOnChange={handleMapOnChange}
              renderMapMarkers={renderMapMarkers}
              gestureHandlingValue="cooperative"
              darkMode
            />
          )}
        </Box>
      </Grid>
    </StyledGrid>
  );
};

export { ParticipatingLocations };